// extracted by mini-css-extract-plugin
export default {"eventsWrapper":"LiveEventsList_eventsWrapper__smcLW","noOffer":"LiveEventsList_noOffer__zibRp"};